module.exports = __webpack_public_path__ + "img/chevron-up-rounded.00d174c4.svg";